import { DatePicker, Form, Input } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { PropsWithChildren, useContext } from "react";

import { EditableContext } from "../DragAndDrop/context";

interface EditableCellProps extends PropsWithChildren {
    editing: boolean;
    dataIndex: string;
    inputType: string;
    className?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export const EditableCell: React.FC<EditableCellProps> = ({
    editing,
    children,
    style,
    dataIndex,
    inputType,
    ...restProps
}) => {
    const form = useContext(EditableContext);

    const handleChange = (fieldName: string, value: unknown) => {
        form?.setFieldValue(fieldName, value);
    };

    const formatInitialValue = () => {
        switch (inputType) {
            case "text":
                return restProps[dataIndex];
            case "date":
                return dayjs(restProps[dataIndex]);
            default:
                return restProps[dataIndex];
        }
    };

    return (
        <td style={style} {...restProps}>
            {editing ? (
                <Form.Item name={dataIndex} initialValue={formatInitialValue()}>
                    {renderInput(inputType, restProps[dataIndex], handleChange, dataIndex)}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const renderInput = (
    inputType: string,
    defaultValue: string,
    handleChange: (dataIndex: string, value: string | Dayjs) => void,
    dataIndex: string
) => {
    switch (inputType) {
        case "text":
            return <Input defaultValue={defaultValue} onChange={(e) => handleChange(dataIndex, e.target?.value)} />;
        case "date":
            return (
                <DatePicker
                    format="YYYY-MM-DD"
                    defaultValue={defaultValue ? dayjs(defaultValue) : null}
                    onChange={(date) => handleChange(dataIndex, date)}
                />
            );
        default:
            return <Input defaultValue={defaultValue} onChange={(e) => handleChange(dataIndex, e.target?.value)} />;
    }
};
